const arrayIntersection = (a: any[], b: any[]) => {
  if (!a || !b) return [];

  return a.filter((value) => b.includes(value));
};

export default arrayIntersection;
